const IP_AND_USER_KEYS = ['forwarded', '-ip', 'remote-', 'via', '-user'];

/**
 * Sentry 11 replaced `sendDefaultPii` with `dataCollection` and, when it is left
 * unset, collects user info, cookies, HTTP headers/bodies and GraphQL data by
 * default. This is the configuration Sentry's v11 migration guide gives to keep
 * v10's restrictive defaults, which is what this site ran with (it never set
 * `sendDefaultPii`). Shared by `hooks.client.ts` and `hooks.server.ts`.
 */
export const sentryDataCollection = {
	userInfo: false,
	cookies: false,
	httpHeaders: {
		request: { deny: IP_AND_USER_KEYS },
		response: { deny: IP_AND_USER_KEYS },
	},
	httpBodies: [],
	urlQueryParams: { deny: IP_AND_USER_KEYS },
	genAI: { inputs: false, outputs: false },
	databaseQueryData: false,
	queues: false,
	graphQL: { document: false, variables: false },
};
